import {Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit} from '@angular/core';
import {AlertController, IonicModule, ModalController} from '@ionic/angular';
import {CommonModule} from '@angular/common';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {RankingEntry} from '../../model/ranking-entry';
import {ComponentsModule} from '../components.module';
import {RouterLink} from '@angular/router';
import {Boulder} from '../../model/boulder';
import {RankingService} from '../../services/ranking.service';
import { UsernameComponent } from '../username/username.component';

type RankingType = 'creator' | 'boulderer';

@Component({
  standalone: true,
  selector: 'ranking-list',
  imports: [IonicModule, CommonModule, TranslateModule, ComponentsModule, RouterLink, UsernameComponent],
  templateUrl: 'ranking-list.component.html',
  styleUrls: ['ranking-list.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RankingList implements OnInit {

  @Input('boulders')
  boulders: Boulder[];

  @Input('showHeader')
  showHeader: false;

  rankingType: RankingType = 'boulderer';
  ranking: RankingEntry[];

  constructor(
    private translate: TranslateService,
    private alertController: AlertController,
    private rankingService: RankingService,
    private modalCtrl: ModalController) {

  }

  ngOnInit(): void {
    this.reloadRanking();
  }

  async showInfo() {
    const alert = await this.alertController.create({
      header: this.rankingType == 'boulderer' ? this.translate.instant('ranking-page.boulderer-score') : this.translate.instant('ranking-page.creator-score'),
      message: this.rankingType == 'boulderer' ? this.translate.instant('ranking-page.boulderer-ranking-info') : this.translate.instant('ranking-page.creator-ranking-info'),
      cssClass: 'bb-alert'
    });
    await alert.present();
  }

  rankingChanged($event: any) {
    this.rankingType = $event.detail.value;
    this.reloadRanking();
  }

  onSwipeRight() {
    this.rankingType = 'creator';
    this.reloadRanking();
  }

  onSwipeLeft() {
    this.rankingType = 'boulderer';
    this.reloadRanking();
  }

  async dismiss() {
    const top = await this.modalCtrl.getTop();
    if (top) {
      await top.dismiss();
    }
  }


  async reloadRanking() {
    this.ranking = null;
    if (this.rankingType == 'boulderer') {
      this.ranking = this.rankingService.calculateBouldererRating(this.boulders);
    } else if (this.rankingType == 'creator') {
      this.ranking = this.rankingService.calculateCreatorRating(this.boulders);
    }
  }

}
